import { Component, forwardRef, Renderer2, ViewChild, Input, Output, OnChanges, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { VenueService } from '../../../service/venue/venue.service';

export const EPANDED_TEXTAREA_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SelectVenueComponent),
  multi: true,
};

@Component({
  selector: 'app-select-venue',
  templateUrl: './select-venue.component.html',
  styleUrls: ['./select-venue.component.scss'],
  providers: [EPANDED_TEXTAREA_VALUE_ACCESSOR],
})
export class SelectVenueComponent implements ControlValueAccessor,OnChanges {
    @Input() venueId: number;
    @ViewChild('input') textarea;
    @Input() disabled: boolean;
    @Output() onMyChange = new EventEmitter();

    public venuesOptions: any[];

    public onChange;
    public onTouched;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public query: string;
    public filters: {key: string, value: string}[];

    constructor(
        private renderer: Renderer2,
        public venueService: VenueService
    ) {
        this.page = 1;
        this.per_page = 10;
        this.query = undefined;
        this.filters = [];
        this.filters.push({key: 'activated-lk', value: '1'});
        //this.getVenues(this.query, this.filters);
    }
    ngOnInit(){
        // this.getVenues(this.query, this.filters);
    }
    ngOnChanges(){
        this.getVenues(this.query, this.filters);//this.ngOnInit();
    }
    writeValue(value: any ) {
        const div = this.textarea.nativeElement;
        // this.renderer.setProperty(div, 'textContent', value);
    }

    registerOnChange(fn: any ) {
        this.onChange = fn;
    }

    registerOnTouched(fn: any ) {
        this.onTouched = fn;
    }

    // setDisabledState(isDisabled: boolean ) {
    //     const div = this.textarea.nativeElement;
    //     const action = isDisabled ? 'addClass' : 'removeClass';
    //     this.renderer[action](div, 'disabled');
    // }

    setDisabledState(isDisabled: boolean ) {
        this.disabled = isDisabled;
    }

    public change($event) {
        this.onMyChange.emit($event.target.value);
        this.onChange($event.target.value);
        this.onTouched($event.target.value);
    }

    getVenues(query?: string, filters?: any[]) {
        this.venueService.getVenue(this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
            response => {
                const venues = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }

                this.venuesOptions = [];
                this.venuesOptions.push({id: undefined, name: 'choose', company: undefined});
                venues.forEach(element => {
                    if (this.venueId == element.id) {
                        this.venuesOptions.push({id: element.id, name: element.name, selected: true, company: element.company});
                    } 
                    else {
                        this.venuesOptions.push({id: element.id, name: element.name, selected: false, company: element.company});
                    }
                });
                
            },
            error => {
                this.venuesOptions = [];
                this.venuesOptions.push({id: '', name: 'Error'});
            }
        );
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/venues/select-venue/select-venue.component.ts